// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3PPFv","list":"BalanceDue_list__b5E7d","listRow":"BalanceDue_listRow__QPEko","total":"BalanceDue_total__1HTif"};